import {AfterViewInit, Component, OnInit} from '@angular/core';
import {QuestionInput} from '../question-input';
import {MatRadioChange} from '@angular/material';
import {QuestionInfo, QuestionModel} from '../../model/question.model';
import {ChoiceQuestion} from '../../model/questions/choise-question';
import {TextQuestion} from '../../model/questions/text-question';
import {NumberQuestion} from '../../model/questions/number-question';

@Component({
  selector: 'app-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss']
})
export class RadioGroupComponent extends QuestionInput implements OnInit, AfterViewInit {


  constructor() {
    super();
  }

  ngOnInit() {


  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   const checked = !!this.question.choices.find(j => j.selected);
    //   this.questionAnswered.emit(checked);
    // });

  }

  get answer(): any {
    const value = this.question.choices.find(j => j.selected).value;
    return value;
  }

  valueChanged(event) {
    this.question.choices.forEach(j => j.selected = false);
    this.question.choices.find(j => j.value == event.target.value).selected = true;
    this.questionAnswered.emit(true);
  }

}
